<div *ngIf="params.filter !== 'completedAmlCheck'">
  <mat-form-field>
    <input
      matInput
      name=""
      type="text"
      class="form-control"
      id=""
      placeholder=""
      (input)="filterSearchText.next($event)"
      [(ngModel)]="filterText"
    />
  </mat-form-field>
</div>

<div
  *ngIf="params.filter === 'completedAmlCheck'"
  class="d-flex flex-row align-items-center justify-content-center test"
>
  <mat-checkbox
    (click)="$event.stopPropagation()"
    (change)="onFilterCompletedAML($event)"
  ></mat-checkbox>
</div>

<!-- <ng-container *ngIf="params.filter === 'date_of_birth'">
  <div class="input-group m-auto input-grp-p mr-3">
    <input
      class="datepicker-here form-control"
      (dateSelect)="
        onFilterSearchText.emit({
          elem: params.filter,
          value: $event,
          filter: params.filter
        })
      "
      ngbDatepicker
      #from="ngbDatepicker"
      placeholder="Select date to filter"
      (click)="from.toggle()"
    />
    <div class="input-group-append">
      <button class="btn calendar" (click)="from.toggle()" type="button">
        <i class="fa fa-calendar"></i>
      </button>
    </div>
  </div>
</ng-container> -->
